import React, {useEffect, useState, useMemo} from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import { DataGrid } from '@material-ui/data-grid';
import { Button, IconButton, Tooltip, Typography } from '@material-ui/core';
import { useDialog } from '../../../hooks/useDialog';
import { Dialog } from '../../Dialog/Dialog';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { AddDocumentTableConstructor } from '../TableConstructorFieldFiller/AddDocumentTableConstructor';
import DescriptionIcon from '@material-ui/icons/Description';
import { ExcelExport } from './ExcelExport';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { deleteIdTable, getColumnsOffenseWindows, mutateHead, numberDateTime } from './TableConstructorFieldfunc'
import AddIcon from '@material-ui/icons/Add';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DeleteIcon from '@material-ui/icons/Delete';
import { styled } from 'styled-components'
import { useFormik } from 'formik';

const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiDataGrid-columnsContainer': {
            borderBottom: '2px solid #000000'
        }
    },
    button: {
        color: '#0A8100',
        border: '2px solid #0A8100',
        width: '100%',
        marginBottom: '2px',
        display: 'flex',
        justifyContent: 'space-between'
    },
    iconExcel: {
        height: '30px',
        width: '30px',
    },
    halperTableText: {
        color: 'green',
        fontSize: '18px',
        fontStyle: 'italic',
        marginLeft: '10px',
        marginBottom: '10px' 
    },
    block: {
        display: 'block'
    },
    export: {
        color: 'blue'
    }
}))

const Block = styled.div`
    display: flex;
    align-items: center;
`


export const TableConstructorField = (props) => {


    const {content, variable, value, setFieldValue, helperText} = props;


    const classes = useStyles()
    const {
        values,
        setValues
    } = useFormik(
        {
            initialValues: value.data
        }
    )

    const TableConstructorDialog = useDialog()
    const TableConstructorImportDialog = useDialog()


    const [columns, setColumns] = useState(content.adminColumns);

    const [dateTable, setDateTable] = useState([])

    const [fileName, setFileName] = useState(typeof value !== 'object' ? content.fileName : value.fileName)

    const [rowsForExport, setRowsForExport] = useState(deleteIdTable(value  ? value.data : content.adminRows))
    const [headerForExport, ] = useState(mutateHead(content.adminHead, columns))
    const [rowsForExportAdmin, ] = useState(deleteIdTable(value  ? value.data : content.adminRows))

    const [errorColumn, setErrorColumn] = useState(false)
    const [successColumn, setSuccessColumn] = useState(false)

    const [selectionModel, setSelectionModel] = useState([])

    useMemo(() => {
        setRowsForExport(deleteIdTable(value  ? value.data : content.adminRows))
    }, [values]);

    const handleRowChange = (params) => {

        let getRows = JSON.parse(JSON.stringify(values))
        let newRows = []
        getRows.map(row => {
                if (row.id === params.id) {
                    if (dateTable.includes(params.field)) {
                        let newRow = row
                        newRow[params.field] = typeof params.value !== 'string' ? params?.value.toLocaleDateString() : 'Invalid Date'
                        newRows.push(newRow)
                    } else {
                    let newRow = row
                    newRow[params.field] = params.value
                    newRows.push(newRow)}
                } else newRows.push(row)
        })
        
        setValues(newRows)
    }

    const addEmptyRow = () => {
        let getRow = JSON.parse(JSON.stringify([...values][values.length-1]))
        let getRows = JSON.parse(JSON.stringify(values))
        getRow.id = values.length
        getRows.push(getRow)
        getRows = getRows.map((obj, i) => ({ ...obj, id: i + 1 }));
        setValues(getRows)

    }

    const deleteRow = () => {
        const copyRows = JSON.parse(JSON.stringify(values));
        const copySelect = JSON.parse(JSON.stringify(selectionModel))

        if (copyRows?.length === copySelect?.length) {
            return
        }
        let newRows = copyRows.filter((element) => !copySelect.includes(element.id))
        // newRows = newRows.map((obj, i) => ({ ...obj, id: i + 1 }));
        setValues(newRows)
        setSelectionModel([]);
    }

    const pushUpRow = () => {
        const copyRows = JSON.parse(JSON.stringify(values));
        const selectRow = JSON.parse(JSON.stringify(selectionModel))[0];

        const upList = copyRows.slice(0, selectRow - 1);
        const downList = copyRows.slice(selectRow - 1, copyRows.length);

        const helpPer = upList.at(-1);
        upList[upList.length - 1] = downList[0];
        downList[0] = helpPer;
        upList[upList.length - 1].id = upList.length;
        downList[0].id = upList.length + 1;

        setSelectionModel((prevId) => {
            return [prevId[0] - 1]
        });

        setValues(upList.concat(downList))
    }

    const pushDownRow = () => {
        const copyRows = JSON.parse(JSON.stringify(values));
        const selectRow = JSON.parse(JSON.stringify(selectionModel))[0];

        const upList = copyRows.slice(0, selectRow);
        const downList = copyRows.slice(selectRow, copyRows.length);

        const helpPer = downList[0];
        downList[0] = upList.at(-1);
        upList[upList.length - 1] = helpPer;
        upList[upList.length - 1].id = upList.length;
        downList[0].id = upList.length + 1;

        setSelectionModel((prevId) => {
            return [prevId[0] + 1]
        });

        setValues(upList.concat(downList))
    }

   

    useEffect(() => {
        setDateTable(numberDateTime(content.offenseWindow))
        setColumns(getColumnsOffenseWindows(content.offenseWindow, values, setValues))
    },[content, values, TableConstructorDialog.open, setValues])
 
    useEffect(() => {
        if (typeof value !== 'object') {
            setValues(content.adminRows)
        }  else {
            setValues(value.data)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])

    const CustomToolbarExcel = () =>  {

        const [anchorEl, setAnchorEl] = React.useState(null);

        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        const handleImportUserExcelTable = () => {
            TableConstructorImportDialog.handleOpen()
        }

        return(
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div>
                    <Block>
                        <Tooltip    
                            title="Добавить строку"
                        >   
                            <IconButton
                                onClick={addEmptyRow}
                            >
                                
                                <AddIcon />
                            </IconButton> 
                            
                        </Tooltip>
                        
                        <Tooltip    
                            title="Удалить строку"
                        >   
                            <IconButton
                                onClick={deleteRow}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip    
                            title="Поднять на одну строку вверх"
                        >   
                            <IconButton
                                onClick={pushUpRow}
                                disabled={selectionModel.length>1 || selectionModel.length==0 || selectionModel[0]==1}

                            >
                                <ArrowDropUpIcon />
                            </IconButton> 
                            
                        </Tooltip>
                        <Tooltip    
                            title="Спустить на одну строку вверх"
                        >   
                            <IconButton
                                onClick={pushDownRow}
                                disabled={selectionModel.length>1 || selectionModel.length==0 || selectionModel[0]==values.length}

                            >
                                <ArrowDropDownIcon />
                            </IconButton> 
                            
                        </Tooltip>


                    </Block>
                </div>
                <div style={{ marginRight: '20px'}}>
                    <Button 
                        style={{marginTop: '10px', marginBottom: '10px', marginLeft: '10px'}}
                        aria-controls="simple-menu" 
                        aria-haspopup="true" 
                        onClick={handleClick}
                        variant='contained'
                        color="primary"
                    >
                        Excel документы
                    </Button>   
                    <Menu
                        id="excelMenu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem>
                            <ExcelExport 
                                rows = {rowsForExportAdmin}
                                head = {headerForExport}
                                file = {fileName}
                                title = {`Cкачать данные администратора`}
                                columns = {columns}
                            />
                        </MenuItem>
                        <MenuItem>
                            <ExcelExport 
                                rows = {[]}
                                head = {headerForExport}
                                file = {fileName}
                                title = {`Скачать шапку таблицы`}
                                columns={columns}
                            />
                        </MenuItem>
                        <MenuItem>
                            <ExcelExport 
                                rows = {rowsForExport}
                                head = {headerForExport}
                                file = {fileName}
                                title = {`Cкачать сохраненные данные`}
                                columns={columns}
                            />
                        </MenuItem>
                        <MenuItem onClick={handleImportUserExcelTable}>Загрузить свой документ</MenuItem>
                    </Menu>
                    <Dialog
                        open={TableConstructorImportDialog.open}
                        handleClose={TableConstructorImportDialog.handleClose}
                        title={'Загрузка файла'}
                        maxWidth={"lg"} 
                        fullWidth={true}
                    >
                        <AddDocumentTableConstructor 
                            setValues={setValues}
                            setColumns={setColumns}
                            setFieldValue={setFieldValue}
                            variable={variable}
                            handleClose={TableConstructorImportDialog.handleClose}
                            setFileName={setFileName}
                            offenseWindow={content.offenseWindow}
                            setErrorColumn={setErrorColumn}
                            setSuccessColumn={setSuccessColumn}
                        />
                    </Dialog>
                </div>
                
            </div>
            );
    }

    const handleCloseErrorColumn = () => {
        setErrorColumn(false)
    }

    const handleCloseSuccessColumn = () => {
        setSuccessColumn(false)
    }

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    return (
        <React.Fragment>
            <div className={classes.block}>
                <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => {TableConstructorDialog.handleOpen()}}
                    className={classes.button}
                >
                    {fileName} 
                    <DescriptionIcon className={classes.iconExcel} />
                </Button>
                <Typography className={classes.halperTableText}>
                    {helperText}
                </Typography>
            </div>
            <Dialog
                open={TableConstructorDialog.open}
                handleClose={() => {
                    setSelectionModel([])

                    setValues(value?.data ? value?.data : content.adminRows)

                    TableConstructorDialog.handleClose();
                }}
                title={fileName?.toUpperCase() ?? 'Таблица без названия'}
                actions={<Button onClick={() => { 
                    setFieldValue(variable, { 
                        fileName: fileName,
                        data: values,
                    });
                    setValues(values)
                    setSelectionModel([])
                    TableConstructorDialog.handleClose()
                }
                }>Сохранить</Button>}
                maxWidth={"lg"} 
                fullWidth={true}
            >
                {values &&
                    <div style={{ height: '80vh', width: '100%' }}>
                        <DataGrid
                            rows={values}
                            columns={columns}
                            pageSize={[25]}
                            components={{
                                Toolbar: CustomToolbarExcel,
                              }}
                            classes={{root: classes.root}}
                            onCellEditCommit={handleRowChange}
                            onSelectionModelChange={(ids) => {
                                setSelectionModel(ids);
                              }}
                              
                            selectionModel={selectionModel}
                            checkboxSelection
                            disableSelectionOnClick
                        />
                        <Snackbar open={errorColumn} autoHideDuration={6000} onClose={handleCloseErrorColumn}>
                            <Alert onClose={handleCloseErrorColumn} severity="error">
                                Количество колонок таблицы не совпадает!!!
                            </Alert>
                        </Snackbar>
                        <Snackbar open={successColumn} autoHideDuration={6000} onClose={handleCloseSuccessColumn}>
                            <Alert onClose={handleCloseSuccessColumn} severity="success">
                                Файл успешно загружен
                            </Alert>
                        </Snackbar>
                    </div> 
                }
            </Dialog>
        </React.Fragment>
        );
}